import { createAction, props } from '@ngrx/store';
import { EmailTemplate } from './email-template.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records email template'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records email template success', 
    props<{ listData: EmailTemplate[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records email template failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record email template',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record email template success', 
    props<{ singleData: EmailTemplate }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record email template failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record email template',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record email template success'
);
export const addRecordFailure = createAction(
    '[Data] Add record email template failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record email template',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record email template success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record email template failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record email template',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record email template success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record email template failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state email template',
);